import { render, staticRenderFns } from "./BudgetManager.vue?vue&type=template&id=40c31dd0&scoped=true&"
import script from "./BudgetManager.vue?vue&type=script&lang=js&"
export * from "./BudgetManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c31dd0",
  null
  
)

export default component.exports